import { Base } from '@studiometa/js-toolkit';
import { nextFrame } from '@studiometa/js-toolkit/utils';

/**
 * GlossaryTerm component
 */
export default class Tooltip extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Tooltip',
    options: {
      endpoint: {
        type: String,
      },
    },
  };

  /**
   * is tooltip open.
   * @type {boolean}
   */
  isOpen = false;

  /**
   * has tooltip been created.
   * @type {boolean}
   */
  isCreated = false;

  /**
   * Template.
   * @type {string}
   */
  template = '';

  /**
   * Template.
   * @type {HTMLElement}
   */
  tooltipElement;

  /**
   * Close the tooltip on `ESC`.
   * @param  {object}       props   keyed props
   * @param  {boolean}      props.isUp   Is it a keyup event?
   * @param  {boolean}      props.ESC    Is it the ESC key?
   * @returns {void}
   */
  keyed({ isUp, ESC }) {
    if (!this.isOpen) {
      return;
    }

    if (ESC && isUp) {
      this.close();
    }
  }

  /**
   * onClick
   * @param {Event} event object
   * @returns {self}
   */
  async onClick(event) {
    // Prevent reopening when clicking the close button
    if (event.target.classList.contains('tooltip__close')) {
      return this;
    }

    // if tooltip is already created, just open it
    if (this.isCreated) {
      return this.open();
    }

    await this.insertTooltip();
    this.open();

    this.template = await fetch(this.$options.endpoint).then((response) => {
      return response.text();
    });

    this.tooltipElement.innerHTML = this.template;

    // bind close button to close
    nextFrame(() => {
      const closeBtn = this.$el.querySelector('.tooltip__close');
      closeBtn.addEventListener('click', this.close);
    });

    return this;
  }

  /**
   * Create a tooltip
   */
  insertTooltip() {
    this.tooltipElement = document.createElement('div');
    this.tooltipElement.classList.add('tooltip');
    this.$el.append(this.tooltipElement);

    this.isCreated = true;
  }

  /**
   * Open the tooltip
   */
  open() {
    this.tooltipElement.classList.add('is-tooltip-open');

    const clickOutsideHandler = (event) => {
      if (!this.$el.contains(event.target) || event.target.classList.contains('tooltip__close')) {
        document.removeEventListener('click', clickOutsideHandler);
        this.close();
      }
    };
    document.addEventListener('click', clickOutsideHandler);

    this.isOpen = true;
  }

  /**
   * Close the tooltip
   */
  close() {
    this.isOpen = false;
    if (this.tooltipElement.classList.contains('is-tooltip-open')) {
      this.tooltipElement.classList.remove('is-tooltip-open');
    }
  }
}
